export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";